<div class="container mt-4 d-flex justify-content-center" *ngIf="agentData">

  <div class="agent-wrapper">

    <h4 class="text-center mb-3"><b>Agent Accreditation Details</b></h4>

    <div class="card">
      <ul class="list-group list-group-flush">

        <li class="list-group-item d-flex justify-content-between">
          <b>Election Type : </b> &nbsp;
          <span class="value">{{agentData.election_type_name}}</span>
        </li>

        <li class="list-group-item d-flex justify-content-between">
          <b>Candidate Name : </b>
          <span class="value">{{agentData.candidate_name}}</span>
        </li>

        <li class="list-group-item d-flex justify-content-between">
          <b>Registration Number : </b>
          <span class="value">{{agentData.candidate_registration_number}}</span>
        </li>

        <li class="list-group-item d-flex justify-content-between">
          <b>Agent Name : </b>
          <span class="value">{{agentData.agent_name}}</span>
        </li>

        <li class="list-group-item d-flex justify-content-between">
          <b>Agent Registration Number : </b>
          <span class="value">{{agentData.agent_registration_number}}</span>
        </li>

      </ul>
    </div>

  </div>

</div>